export default [ 'api', function (api) {
  return {
    validate: (basketCode, voucherCode) => {
      return api.get(`api/${basketCode}/vouchercode/${voucherCode}`).
        then(response => response.data);
    }
  };
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/voucher.api.service.js